import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';
import PropTypes from 'prop-types';
export var withTooltipPropTypes = {
  tooltipOpen: PropTypes.bool,
  tooltipLeft: PropTypes.number,
  tooltipTop: PropTypes.number,
  tooltipData: PropTypes.object,
  updateTooltip: PropTypes.func,
  showTooltip: PropTypes.func,
  hideTooltip: PropTypes.func
};
export default function withTooltip(BaseComponent, containerProps) {
  if (containerProps === void 0) {
    containerProps = {
      style: {
        position: 'relative',
        width: 'inherit',
        height: 'inherit'
      }
    };
  }

  var WrappedComponent =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inheritsLoose(WrappedComponent, _React$PureComponent);

    function WrappedComponent(props) {
      var _this;

      _this = _React$PureComponent.call(this, props) || this;
      _this.state = {
        tooltipOpen: false,
        tooltipLeft: undefined,
        tooltipTop: undefined,
        tooltipData: undefined
      };
      _this.updateTooltip = _this.updateTooltip.bind(_assertThisInitialized(_this));
      _this.showTooltip = _this.showTooltip.bind(_assertThisInitialized(_this));
      _this.hideTooltip = _this.hideTooltip.bind(_assertThisInitialized(_this));
      return _this;
    }

    var _proto = WrappedComponent.prototype;

    _proto.updateTooltip = function updateTooltip(_ref) {
      var tooltipOpen = _ref.tooltipOpen,
          tooltipLeft = _ref.tooltipLeft,
          tooltipTop = _ref.tooltipTop,
          tooltipData = _ref.tooltipData;
      this.setState(function (prevState) {
        return _extends({}, prevState, {
          tooltipOpen: tooltipOpen,
          tooltipLeft: tooltipLeft,
          tooltipTop: tooltipTop,
          tooltipData: tooltipData
        });
      });
    };

    _proto.showTooltip = function showTooltip(_ref2) {
      var tooltipLeft = _ref2.tooltipLeft,
          tooltipTop = _ref2.tooltipTop,
          tooltipData = _ref2.tooltipData;
      this.updateTooltip({
        tooltipOpen: true,
        tooltipLeft: tooltipLeft,
        tooltipTop: tooltipTop,
        tooltipData: tooltipData
      });
    };

    _proto.hideTooltip = function hideTooltip() {
      this.updateTooltip({
        tooltipOpen: false,
        tooltipLeft: undefined,
        tooltipTop: undefined,
        tooltipData: undefined
      });
    };

    _proto.render = function render() {
      return React.createElement("div", containerProps, React.createElement(BaseComponent, _extends({
        updateTooltip: this.updateTooltip,
        showTooltip: this.showTooltip,
        hideTooltip: this.hideTooltip
      }, this.state, this.props)));
    };

    return WrappedComponent;
  }(React.PureComponent);

  return WrappedComponent;
}